import ForgotPasswordComponent from "../components/Auth/ForgotPasswordComponent";

const ForgotPasswordPage = () => {
  return <ForgotPasswordComponent />;
};
export default ForgotPasswordPage;
